//---------------------------------------------
// Membros Module 
//---------------------------------------------
// Módulo para gerenciar as ações dos membros

import axios from '../../services/api';
import Cookies from 'js-cookie';
// var qs = require('qs');
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listMembros: [],
    listMembrosMunicipio: [],
    userPerm: [],
    memberById:[],

    //VERIFICACAO DE ERRO
    isAlreadyRegisteredUser: false,
    isDeleted: false,

    memberHasBeenUpdated: null,
    regionalMemberHasBeenUpdated: null,

    regMemberHasBeenDeleted: null,
    munMemberHasBeenDeleted:null,
})

// MUTATIONS
const mutations = {
    //-- MUTATION REQUISICAO DO LISTMEMBROS
    setListMembros(state, payload) {
        state.listMembros = payload
    },

    //-- MUTATION REQUISICAO DO LISTMEMBROS
    setListMembrosMunicipio(state, payload) {
        state.listMembrosMunicipio = payload
    },

    //-- MUTATION PERMISSAO DO USER
    setUserPerm(state, payload) {
        state.userPerm = payload
    },

    //-- MUTATION VERIIFCAR SE O USER JA FOI CADASTRADO
    setIsAlreadyRegisteredUser(state, payload) {
        state.isAlreadyRegisteredUser = payload
    },

    //-- MUTATION VERIIFCAR SE O USER FOI DELETADO
    setIsDeleted(state, payload) {
        state.isDeleted = payload
    },

    setMemberById(state, payload) {
        state.memberById = payload
    },

    //-- UPDATE ERROR
    setMemberUpdatedStatus(state,payload){
        state.memberHasBeenUpdated = payload
    },
    setRegionalMemberStatus(state,payload){
        state.regionalMemberHasBeenUpdated = payload
    },

    //--DELETE ERROR
    setDeleteMemberReg(state,payload){
        state.regMemberHasBeenDeleted = payload
    },
    setDeleteMemberMun(state,payload){
        state.munMemberHasBeenDeleted = payload
    },
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DE CRIAR MEMBRO 
    async setCreateMember({commit}, payload) {
        await axios
            .post(`membros/${payload.idMunicipio}`, {
                    idPermissao: payload.idPermissao,
                    email: payload.email
                },{
           
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(() => {
                commit('setIsAlreadyRegisteredUser', false)
            })
            .catch((error) => {
                commit('setIsAlreadyRegisteredUser', true)
                console.log(error.message)
            })
    },


     //-- ACTION REQUISICAO DE ATUALIZAR MEMBRO 
    async setUpdateMember({ commit }, payload) {
        await axios
            .put(`membros-municipio/${payload.idMunicipio}`, {
                    idUsuario: payload.idUsuario,
                    idPermissao: payload.idPermissao,
                    idUe: payload.idUe? payload.idUe : null
                },{
           
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(() => {     
                commit('setMemberUpdatedStatus', true)
            })
            .catch(() => {
                commit('setMemberUpdatedStatus', false)
            })
    },

     //-- ACTION REQUISICAO DE ATUALIZAR MEMBRO REGIONAL
    async setUpdateMemberRegional({ commit }, payload) {
        await axios
            .put(`membros-regional/${payload.idRegional}`, {
                    idUsuario: payload.idUsuario,
                    idPermissao: payload.idPermissao,
                },{
           
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(() => {     
                commit('setRegionalMemberStatus', true)
            })
            .catch(() => {
                commit('setRegionalMemberStatus', false)
            })
    },

    //-- ACTION REQUISICAO DO LISTMEMBROS MUNICIPAL, ASSISTENTE, APLICADOR
    async setListMembros({ commit }, idMunicipio) {
        await axios
            .get(`membros-municipio/${idMunicipio}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMembros', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO MEMBROS DO MUNICIPIO EM CAMPOS
    async setListMembrosMunicipio({ commit }, idMunicipio) {
        await axios
            .get(`membros-municipio/list/${idMunicipio}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMembrosMunicipio', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTMEMBROS REGIONAL
    async setListMembrosRegional({ commit }, idRegional) {
        await axios
            .get(`membros-regional/${idRegional}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMembros', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTMEMBROS UE
    async setListMembrosUe({ commit }, idUe) {
        await axios
            .get(`membros-ue/${idUe}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMembros', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DE TODOS OS MEMBROS
    async setListAllMembros({ commit }, payload) {
        await axios
            .get(`usuarios`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                },
                params: {
                    idRegional: payload?.idRegional,
                    idMunicipio: payload?.idMunicipio
                },
            })
            .then(response => {
                commit('setListMembros', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DE UM MEMBRO PELO ID
    async setMemberById({ commit }, idUsuario) {
        await axios
            .get(`usuarios/${idUsuario}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setMemberById', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO PARA SABER A PERMISSAO DO MEMBRO
    async setUserPerm({ commit }) {
        await axios
            .get(`usuarios/get-permission`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setUserPerm', response)
            })
            .catch((error) => {
                console.log(error.message);
                commit('setUserPerm', {
                    id_permissao: null
                })
            })
    },

    //-- ACTION DELETE MEMBRO MUNICIPIO
    async deleteMemberMunicipio({ commit }, payload) {
        await axios
            .delete(`membros-municipio/${payload.idEntidade}`, 
            {
                data: {
                    idUsuario: payload.idUsuario
                },
                
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setDeleteMemberMun', true)
            })
            .catch(() => {
                commit('setDeleteMemberMun', false)
            })
    },

    //-- ACTION DELETE MEMBRO REG
    async deleteMemberRegional({ commit }, payload) {
        await axios
            .delete(`membros-regional/${payload.idEntidade}`, 
            {
                data: {
                    idUsuario: payload.idUsuario
                },
                
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(()=> {
                commit('setDeleteMemberReg', true)
            })
            .catch(() => {
                commit('setDeleteMemberReg', false)
            })
    },

    //-- ACTION DELETE MEMBRO UE
    async deleteMemberUe({commit}, payload) {
        await axios
            .delete(`membros-ue/${payload.idEntidade}`,
            {
                data: {
                    idUsuario: payload.idUsuario
                },
                
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsDeleted', true);
            })
            .catch((error) => {
                commit('setIsDeleted', false);
                console.log(error.message);
            })
    },
}

// GETTERS
const getters = {
    getListMembros(state) {
        try {
            return state.listMembros.data
        } catch (e) {
            return []
        }
    },

    getListMembrosMunicipio(state) {
        try {
            return state.listMembrosMunicipio.data
        } catch (e) {
            return []
        }
    },

    getUserPerm(state) {
        try {
            return state.userPerm.data.data
        } catch (e) {
            return []
        }
    },

    getIsAlreadyRegisteredUser(state) {
        return state.isAlreadyRegisteredUser
    },

    getIsDeleted(state) {
        return state.isDeleted
    },

    getMemberById(state) {
        return state.memberById.data
    },

    getRegionalUpdateError(state){
        return state.regionalMemberHasBeenUpdated
    },

    getMemberUpdateError(state){
        return state.memberHasBeenUpdated
    },

    getMemberRegIsDeleted(state){
        return state.regMemberHasBeenDeleted
    },

    getMemberMunIsDeleted(state){
        return state.munMemberHasBeenDeleted
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
